var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('gat-dialog',{attrs:{"cancelButtonCaption":"","okButtonCaption":"OK","title":_vm.title},on:{"okClick":_vm.okClicked},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('span',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }